import {
    Box,
    Icon,
    ListItemIcon,
    Menu,
    MenuItem,
    Tooltip,
    useAppDispatch,
} from '../../../../base';
import { IconButton } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { loginActions } from '../../../../actions';
import { RoutePaths } from '../../../../routes/RoutePaths';

const UserManagementMenu = () => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleLogout = () => {
        dispatch(loginActions.logout());
    };

    return (
        <>
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    textAlign: 'center',
                    height: '25px',
                }}
            >
                <Tooltip title={t('topBar.accountSettings')}>
                    <IconButton
                        onClick={handleClick}
                        size="small"
                        sx={{ marginInlineStart: 2 }}
                        aria-controls={open ? 'account-menu' : undefined}
                        aria-haspopup="true"
                        aria-expanded={open ? 'true' : undefined}
                        sx={{ height: '25px', width: '25px' }}
                    >
                        <Icon name={'ExpandMoreOutlinedIcon'} />
                    </IconButton>
                </Tooltip>
            </Box>
            <Menu
                anchorEl={anchorEl}
                id="account-menu"
                open={open}
                onClose={handleClose}
                onClick={handleClose}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            >
                <MenuItem
                    onClick={() => {
                        handleClose();
                        navigate(RoutePaths.userSettings);
                    }}
                >
                    <ListItemIcon>
                        <Icon name={'SettingsOutlinedIcon'} size={24} />
                    </ListItemIcon>
                    {t('topBar.userEditProfile')}
                </MenuItem>
                <MenuItem onClick={handleLogout}>
                    <ListItemIcon>
                        <Icon name={'LogoutOutlinedIcon'} />
                    </ListItemIcon>
                    {t('topBar.userLogout')}
                </MenuItem>
            </Menu>
        </>
    );
};

export default UserManagementMenu;
